import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { AccountAPI } from '../../services/accountAPI';
@inject(AuthService, UserMessageService, Router, AccountAPI)
export class MyVideos {
    constructor(authService, userMessageService, router, api) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.api = api;
       
        const account = this.authService.getAccount();
        this.org_name = account.org_name ? account.org_name : "Magnfi";
        var items = JSON.parse(sessionStorage.getItem("magnfi_account"));
        this.captureKey = items.link_id;

        this.route = "";
        this.route =(localStorage.getItem('rout'))? localStorage.getItem('rout') : ""; 
        console.log("Short Menu Route:",this.route);
        if(this.route.includes("#/user/video/request"))
        {
            this.selected = 1;
        }
        else if(this.route.includes("#/user/video/brand"))
        {
            this.selected = 2;
        }
        else if(this.route.includes("#/user/video/email"))
        {
            this.selected = 3;
        }
        else if(this.route.includes("#/user/video/message"))
        {
            this.selected = 4;
        }
        else if(this.route.includes("#/user/video/caseStudy"))
        {
            this.selected = 5;
        }
        else if(this.route.includes("#/user/contacts"))
        {
            this.selected = 6;
        }
    }
    activate() {

        this.subscriptionType = this.authService.getAccount().subscription_type || '';
        this.isAdmin = this.authService.getUser().role == "ADMIN" || this.authService.getUser().role == "WLADMIN";
        this.setData();
        
        this.load();

        

        this.testimonial_expire_days = window.testimonial_expire_days;
        
    }

    attached() {
        this.requestList.activate();
        this.submissionList.activate();
        this.brandVideoList.activate();
        // if(this.subscriptionType.startsWith('PLUS') || this.isAdmin)
        //     this.videoEmailList.activate();
        // if(this.subscriptionType.startsWith('PLUS') || this.isAdmin)
        //     this.videoMessageList.activate();    
        if(this.subscriptionType.startsWith('PLUS') || this.isAdmin)
            this.caseStudyList.activate();
    }

    load() {
        this.api.getByOwner(
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }

    saveLoadSuccess(data) {
        this.authService.setAccount(data);
        this.setData();
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData() {
        this.requestCount = this.authService.getAccount().request_count;

        this.offset = new Date().getTimezoneOffset();
        if(this.offset<0)
            this.offset = "GMT +"+this.offset/-60;
        else
            this.offset = "GMT -"+this.offset/60;

        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        var date = new Date();
        var h = date.getHours();
        var m = date.getMinutes();
        var session = "AM"; 
        
        //conditions for times behavior 
        if ( h == 0 ) {
            h = 12;
        }
        if( h >= 12 ){
            session = "PM";
        }
        
        if ( h > 12 ){
            h = h - 12;
        }
        m = ( m < 10 ) ? m = "0" + m : m;
        this.current_time = h + ":" + m + " " + session;

        $('.dashboard').css('background', '#fff');
    }

    search($event)
    {
        //alert(this.search_videos);
        //if(this.search_videos)
        {
            console.log("calling testimonial load function for search.");
            this.requestList.load(this.search_videos);
            this.submissionList.load(this.search_videos);
            this.brandVideoList.load(this.search_videos);
            this.caseStudyList.load(this.search_videos);
        }    
    }

    delete($event)
    {
       if (confirm("Are you sure you want to delete selected videos?")) {
            this.requestList.delete($event);
            this.submissionList.delete($event);
            this.brandVideoList.delete($event);
            this.caseStudyList.delete($event);
            this.userMessageService.setUserMessage("user", "Videos Successfully Deleted.");
        }
    }
}
